import React, { useState } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

import {
  Row, Col, Label, Alert,
} from 'reactstrap';

import toastr from 'toastr';
import 'toastr/build/toastr.min.css';

import {
  Formik, Field, Form, ErrorMessage,
} from 'formik';
import * as Yup from 'yup';
import { isNull } from 'lodash';
import { post } from '../../helpers/api_helper';

function PrintLotLabelForm(props) {
  const {
    actionUrl, formData, t, onSuccess,
  } = props;
  const [errorMessage, setErrorMessage] = useState(null);

  toastr.options = {
    positionClass: 'toast-top-right',
    newestOnTop: true,
    extendedTimeOut: 20000,
  };

  const save = async (values) => {
    const toSubmit = { ...values, lot: props.lotId };
    try {
      const result = await post(actionUrl, toSubmit);
      setErrorMessage(null);
      toastr.success(t(`Labels printed for lots ${toSubmit.firstLot} to ${toSubmit.lastLot}`), t('Success'));
      onSuccess(result);
    } catch (error) {
      setErrorMessage(`${error.message}: ${error.response.data}`);
    }
  };

  const ValidationSchema = Yup.object().shape({
    firstLot: Yup
      .number()
      .integer(t('Must be a whole number'))
      .min(1, t('Must be at least 1'))
      .required(t('First lot is required')),
    lastLot: Yup
      .number()
      .integer(t('Must be a whole number'))
      .min(1, t('Must be at least 1'))
      .required(t('Last lot is required')),
  });

  const em = (
    <Alert color="danger" className="mt-3" isOpen={!isNull(errorMessage)}>
      {errorMessage}
    </Alert>
  );

  return (
    <>
      {errorMessage && em}
      <Formik
        enableReinitialize
        initialValues={formData}
        validationSchema={ValidationSchema}
        onSubmit={(values) => {
          save(values);
        }}
      >
        {({ touched, errors }) => (
          <Form className="mt-6" id="PrintLotLabelForm" autoComplete="off">
            <Row>
              <div>{props.lotId}</div>
              <Col md="12">
                <div className="row mt-4 mb-4">
                  <Label
                    htmlFor="firstLot"
                    className="col-md-3 col-form-label"
                  >
                    {t('From')}
                  </Label>
                  <Col md={5}>
                    <Field
                      type="number"
                      className={`form-control ${(errors.firstLot && touched.firstLot ? 'is-invalid' : '')}`}
                      id="firstLot"
                      name="firstLot"
                      min="1"
                    />
                    <ErrorMessage
                      name="firstLot"
                      component="div"
                      className="invalid-feedback"
                    />
                  </Col>
                </div>

                <div className="row mt-4 mb-4">
                  <Label
                    htmlFor="lastLot"
                    className="col-md-3 col-form-label"
                  >
                    {t('To')}
                  </Label>
                  <Col md={5}>
                    <Field
                      type="number"
                      className={`form-control ${(errors.lastLot && touched.lastLot ? 'is-invalid' : '')}`}
                      id="lastLot"
                      name="lastLot"
                      min="1"
                    />
                    <ErrorMessage
                      name="lastLot"
                      component="div"
                      className="invalid-feedback"
                    />
                  </Col>
                </div>
              </Col>
            </Row>
          </Form>
        )}
      </Formik>
    </>
  );
}

PrintLotLabelForm.defaultProps = {
  formData: {
    firstLot: 1,
    lastLot: 26,
  },
  onSuccess: () => {},
};

PrintLotLabelForm.propTypes = {
  actionUrl: PropTypes.string.isRequired,
  t: PropTypes.func.isRequired,
  lotId: PropTypes.string.isRequired,
  formData: PropTypes.shape({
    firstLot: PropTypes.number,
    lastLot: PropTypes.number,
  }),
  onSuccess: PropTypes.func,
};

export default connect(() => ({}), {})(withTranslation()(PrintLotLabelForm));
